// extracted by mini-css-extract-plugin
export default {"container":"sZaco15DbopTZ0IcOLkx","infoBox":"sCszcwGa3Ul2q45kMf9l","name":"o8U75OK35J_9eG78t274","descriptionBox":"QjUaroDC0S7Mm52CKZmN","label":"bfmLCsAHa5Bqz93kTg1l"};